module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"debit":"Debit","credit":"Credit"},"et":{"debit":"Debit","credit":"Credit"},"ru":{"debit":"Debit","credit":"Credit"}}')
  delete Component.options._Ctor
}
